class GalaxyProduct extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.addEventListener('click', event => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) this.showMedia(thumb.dataset.mediaTarget);
      const arrow = event.target.closest('[data-direction]');
      if (arrow) {
        const panels = [...this.querySelectorAll('[data-media-panel]')];
        const index = panels.findIndex(panel => !panel.hidden);
        this.showMedia(panels[(index + Number(arrow.dataset.direction) + panels.length) % panels.length]?.dataset.mediaPanel);
      }
      if (event.target.closest('[data-zoom]')) {
        const img = this.querySelector('[data-media-panel]:not([hidden]) img');
        const dialog = this.querySelector('dialog');
        if (img && dialog) { dialog.querySelector('img').src = img.currentSrc || img.src; dialog.querySelector('img').alt = img.alt; dialog.showModal(); }
      }
      if (event.target.closest('[data-close]')) this.querySelector('dialog').close();
    }, { signal });
    this.addEventListener('change', event => {
      if (event.target.matches('[data-option-value]')) this.updateVariant(event.target);
    }, { signal });
    this.addEventListener('play', event => {
      this.querySelectorAll('audio,video').forEach(media => { if (media !== event.target) media.pause(); });
    }, { capture: true, signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.request?.abort(); }
  showMedia(id) {
    if (!id) return;
    this.querySelectorAll('[data-media-panel]').forEach(panel => {
      panel.hidden = panel.dataset.mediaPanel !== id;
      if (panel.hidden) {
        panel.querySelectorAll('video').forEach(video => video.pause());
        panel.querySelectorAll('iframe').forEach(frame => { const src = frame.src; frame.src = src; });
      }
    });
    this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-current', String(button.dataset.mediaTarget === id)));
    const panels = [...this.querySelectorAll('[data-media-panel]')];
    const count = this.querySelector('[data-gallery-count]');
    if (count) count.textContent = `${String(panels.findIndex(p => p.dataset.mediaPanel === id) + 1).padStart(2, '0')} / ${String(panels.length).padStart(2, '0')}`;
    const zoom = this.querySelector('[data-zoom]');
    if (zoom) zoom.hidden = !this.querySelector('[data-media-panel]:not([hidden]) img');
  }
  async updateVariant(input) {
    if (this.dataset.preview) return;
    this.request?.abort();
    this.request = new AbortController();
    const values = [...this.querySelectorAll('[data-option-value]:checked')].map(el => el.value);
    const url = new URL(input.dataset.productUrl || this.dataset.productUrl, location.origin);
    url.searchParams.set('option_values', values.join(','));
    url.searchParams.set('section_id', this.dataset.section);
    const button = this.querySelector('[name="add"]');
    if (button) button.disabled = true;
    const payment = this.querySelector('.shopify-payment-button');
    if (payment) { payment.hidden = true; payment.inert = true; }
    const quantity = this.querySelector('[name="quantity"]')?.value;
    this.setAttribute('aria-busy', 'true');
    const status = this.querySelector('[data-status]');
    status.textContent = 'Updating your configuration…';
    try {
      const response = await fetch(url, { signal: this.request.signal });
      if (!response.ok) throw new Error('Unable to load configuration');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = doc.querySelector('galaxy-product');
      if (!replacement) throw new Error('Missing product section');
      const focusedId = input.id;
      const openDetails = [...this.querySelectorAll('details[open]')].map(el => el.id);
      this.replaceWith(replacement);
      const newQuantity = replacement.querySelector('[name="quantity"]');
      if (newQuantity && quantity) {
        newQuantity.value = quantity;
        if (!newQuantity.checkValidity()) newQuantity.value = newQuantity.min || '1';
      }
      openDetails.forEach(id => { const el = replacement.querySelector(`#${CSS.escape(id)}`); if (el) el.open = true; });
      replacement.querySelector(`#${CSS.escape(focusedId)}`)?.focus({ preventScroll: true });
      url.searchParams.delete('section_id');
      url.searchParams.delete('option_values');
      if (replacement.dataset.variant) url.searchParams.set('variant', replacement.dataset.variant);
      else url.searchParams.set('option_values', values.join(','));
      history.replaceState({}, '', url);
      replacement.querySelector('[data-status]').textContent = 'Configuration updated.';
    } catch (error) {
      if (error.name === 'AbortError') return;
      status.textContent = 'Unable to update. Please select your option again or refresh the page.';
      this.removeAttribute('aria-busy');
      // Keep purchase disabled: the visible selection no longer matches the submitted variant.
    }
  }
}
if (!customElements.get('galaxy-product')) customElements.define('galaxy-product', GalaxyProduct);
